import { formatMessage as formatLegacyMessage } from '@umijs/max';
import routes from '../../../config/routes';
import { getAccessibleLandingPage } from '@/utils/findFirstAccessibleRoute';
import { getRecentVisitedRoutes } from '@/utils/lastVisitedRoute';
import { history, useAccess, useModel } from '@umijs/max';
import { Button, Space } from 'antd';
import React from 'react';

interface PageRecoveryActionsProps {
  onNavigate?: () => void;
}

const getLoginPath = (pathname: string) => {
  if (pathname.startsWith('/mi/')) {
    return '/mi/mobile/user/login';
  }

  if (pathname.startsWith('/franchise/')) {
    return '/franchise/login';
  }

  return '/user/login';
};

const PageRecoveryActions: React.FC<PageRecoveryActionsProps> = ({ onNavigate }) => {
  const access = useAccess();
  const { initialState } = useModel('@@initialState');
  const pathname = history.location.pathname;
  const currentUser = initialState?.currentUser;
  const userId = currentUser?.id ?? currentUser?.userid;
  const permissions = initialState?.permissions || [];
  const recentPath = currentUser
    ? getRecentVisitedRoutes(userId, access, routes, { excludePath: pathname, limit: 1 })[0]
    : undefined;
  const landingPath = currentUser
    ? getAccessibleLandingPage(access, permissions)
    : getLoginPath(pathname);

  const navigate = (target: string) => {
    onNavigate?.();
    history.replace(target);
  };

  return (
    <Space wrap>
      {recentPath && (
        <Button type="primary" onClick={() => navigate(recentPath)}>
          {formatLegacyMessage({
            id: 'legacyUi.3f95cab0416827bc',
            defaultMessage: '返回上一個有效頁面',
          })}
        </Button>
      )}
      <Button type={recentPath ? 'default' : 'primary'} onClick={() => navigate(landingPath)}>
        {currentUser ? '前往可用首頁' : '返回登入'}
      </Button>
    </Space>
  );
};

export default PageRecoveryActions;
